import React from "react";
import './TeamHealthSpanScoreCard.scss';

const TeamHealthSpanScoreCard = ({
    title,
    dateRangeSubtitle,
    score,
    requirementText,
}) => {
    return (
        <div className="healthspan-card">
            <div className="team-healthspan-score-card">
            <div className="team-healthspan-score-left">
                <div className="team-healthspan-score-header">
                    <span className="team-healthspan-score-title">{title}</span>
                    {dateRangeSubtitle && (
                        <span className="team-healthspan-score-date">{dateRangeSubtitle}</span>
                    )}
                </div>
            </div>
            <div className="team-healthspan-score-value">{score}</div>
            </div>
            {requirementText && (
                <div className="team-healthspan-score-requirement">{requirementText}</div>
            )}
        </div>
    )
}

export default TeamHealthSpanScoreCard;